import React from "react";
import { withTranslation } from "react-i18next";
import stylesWelcome from "./SchedaSpecialeMIB.module.css";
import DatiCompilatoreMIB from "./Sezioni/DatiCompilatoreMIB";
import DatiAnagraficiMIB from "./Sezioni/DatiAnagraficiMIB";
import AgenteEziologicoMIB from "./Sezioni/AgenteEziologicoMIB";
import MalattiaBattericaMIB from "./Sezioni/MalattiaBattericaMIB";
import SqueleFocolaioMIB from "./Sezioni/SqueleFocolaioMIB";
import StatoVaccinaleMIB from "./Sezioni/StatoVaccinaleMIB";
import Button from "../../../../../../components/button/Button";
import Icon from "../../../../../../components/icon/Icon";
import DiagnosiMIB from "./Sezioni/DiagnosiMIB";
import DiagnosiEseguitaNeisseriaMIB from "./Sezioni/DiagnosiEseguitaNeisseriaMIB";
import DiagnosiEseguitaStreptococcus from "./Sezioni/DiagnosiEseguitaStreptococcus";
import DiagnosiEseguitaInfluenzaMIB from "./Sezioni/DiagnosiEseguitaInfluenzaMIB";
import AgenteCausanteMIB from "./Sezioni/AgenteCausanteMIB";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";
import Utils from "../../../../../../utils/Utils";

class SchedaSpecialeMIB extends React.Component {
    state = {
        visualizzaSezione:
            SessioneUtente.getInstance().ruoliUtente ===
            Ruoli.Operatore_Laboratorio.descrizione,
        visualizzaSezioneSISP:
            SessioneUtente.getInstance().ruoliUtente !==
            Ruoli.Operatore_Laboratorio.descrizione,
        schedaSpecialeMIB: {
            datiCompilatoreMIB: {},
            datiAnagraficiMIB: {},
            agenteEziologicoMIB: {
                malattiaBatterica:
                    this.props.segnalazioneCopia &&
                    this.props.segnalazioneCopia.schedaSpeciale &&
                    this.props.segnalazioneCopia.schedaSpeciale
                        .agenteEziologicoMIB &&
                    this.props.segnalazioneCopia.schedaSpeciale
                        .agenteEziologicoMIB.malattiaBatterica
                        ? this.props.segnalazioneCopia.schedaSpeciale
                              .agenteEziologicoMIB.malattiaBatterica
                        : "",
            },
            malattiaBattericaMIB: { corretto: [] },
            sequeleFocolaioMIB: {},
            statoVaccinaleMIB: {},
            diagnosiMIB: {},
            diagnosiNeisseria: { corretto: [] },
            diagnosiStreptococcus: { corretto: [] },
            diagnosiInfluenza: { corretto: [] },
            agenteMIB: { corretto: [] },
        },
        validateMIB: {
            datiAnagraficiMIB: "",
            diagnosiMIB: "",
            statoVaccinaleMIB: "",
        },
        corretto: [],
        confermaScheda: true,
        oggettoBe: {},
    };

    constructor(props) {
        super(props);

        this.mostraElementi = this.mostraElementi.bind(this);
        this.setDiagnosiMIB = this.setDiagnosiMIB.bind(this);
        this.setDiagnosiNeisseriaMIB = this.setDiagnosiNeisseriaMIB.bind(this);
        this.setDiagnosiStreptococcusMIB =
            this.setDiagnosiStreptococcusMIB.bind(this);
        this.setDiagnosiInfluenzaMIB = this.setDiagnosiInfluenzaMIB.bind(this);
        this.setAgenteMIB = this.setAgenteMIB.bind(this);
        this.setDatiCompilatoreMIB = this.setDatiCompilatoreMIB.bind(this);
        this.setDatiAnagraficiMIB = this.setDatiAnagraficiMIB.bind(this);
        this.setAgenteEziologicoMIB = this.setAgenteEziologicoMIB.bind(this);
        this.setMalattiaBattericaMIB = this.setMalattiaBattericaMIB.bind(this);
        this.setSequeleFocolaioMIB = this.setSequeleFocolaioMIB.bind(this);
        this.setStatoVaccinaleMIB = this.setStatoVaccinaleMIB.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia) {
            this.setState({
                pdfAssociato: this.props.segnalazioneCopia.pdfAssociato,
            });
        }
        this.props.setSchedaSpecialeECorretto(
            this.state.oggettoBe,
            "",
            this.state.corretto,
            this.props.segnalazioneCopia &&
                this.props.segnalazioneCopia.stepConfermati &&
                this.props.segnalazioneCopia.stepConfermati
                    .schedaSpecialeConfermata
                ? this.props.segnalazioneCopia.stepConfermati
                      .schedaSpecialeConfermata
                : false
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controlloDati();
    }

    validate() {
        let validate = this.state.validateMIB;

        for (let key in validate) {
            if (validate[key]) {
                return validate[key];
            }
        }

        return "";
    }

    controlloDati() {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let textList = [];
        let textListlab = [];
        let corretto = true;
        let correttoLab = false;
        let correttoSispReg = false;

        if (
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Laboratorio.descrizione &&
            this.state.visualizzaSezione === true
        ) {
            if (
                this.state.schedaSpecialeMIB.agenteEziologicoMIB
                    .malattiaBatterica === "malattiaBatterica1"
            ) {
                if (
                    schedaSpecialeMIB.diagnosiNeisseria.corretto &&
                    schedaSpecialeMIB.diagnosiNeisseria.corretto.length > 0
                )
                    textListlab = textListlab.concat(
                        Utils.eliminaNullArray(
                            schedaSpecialeMIB.diagnosiNeisseria.corretto
                        )
                    );
                if (
                    schedaSpecialeMIB.agenteMIB.corretto &&
                    schedaSpecialeMIB.agenteMIB.corretto.length > 0
                )
                    textListlab = textListlab.concat(
                        Utils.eliminaNullArray(
                            schedaSpecialeMIB.agenteMIB.corretto
                        )
                    );
                corretto = false;
            } else {
                corretto = true;
            }
        } else if (
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Laboratorio.descrizione &&
            this.state.visualizzaSezione === false
        ) {
            corretto = false;
        }

        if (corretto) {
            if (
                schedaSpecialeMIB.datiCompilatoreMIB.corretto &&
                schedaSpecialeMIB.datiCompilatoreMIB.corretto.length > 0
            ) {
                textList = textList.concat(
                    Utils.eliminaNullArray(
                        schedaSpecialeMIB.datiCompilatoreMIB.corretto
                    )
                );
            }
            if (
                schedaSpecialeMIB.datiAnagraficiMIB.corretto &&
                schedaSpecialeMIB.datiAnagraficiMIB.corretto.length > 0
            ) {
                textList = textList.concat(
                    Utils.eliminaNullArray(
                        schedaSpecialeMIB.datiAnagraficiMIB.corretto
                    )
                );
            }
            if (
                schedaSpecialeMIB.malattiaBattericaMIB.corretto &&
                schedaSpecialeMIB.malattiaBattericaMIB.corretto.length > 0
            ) {
                textList = textList.concat(
                    Utils.eliminaNullArray(
                        schedaSpecialeMIB.malattiaBattericaMIB.corretto
                    )
                );
            }
            if (
                schedaSpecialeMIB.agenteEziologicoMIB.corretto &&
                schedaSpecialeMIB.agenteEziologicoMIB.corretto.length > 0
            ) {
                textList = textList.concat(
                    Utils.eliminaNullArray(
                        schedaSpecialeMIB.agenteEziologicoMIB.corretto
                    )
                );
            }
            if (
                schedaSpecialeMIB.sequeleFocolaioMIB.corretto &&
                schedaSpecialeMIB.sequeleFocolaioMIB.corretto.length > 0
            ) {
                textList = textList.concat(
                    Utils.eliminaNullArray(
                        schedaSpecialeMIB.sequeleFocolaioMIB.corretto
                    )
                );
            }
            if (
                schedaSpecialeMIB.statoVaccinaleMIB.corretto &&
                schedaSpecialeMIB.statoVaccinaleMIB.corretto.length > 0
            ) {
                textList = textList.concat(
                    Utils.eliminaNullArray(
                        schedaSpecialeMIB.statoVaccinaleMIB.corretto
                    )
                );
            }

            if (textList.length === 0) {
                correttoSispReg = true;
            } else {
                correttoSispReg = false;
            }
        }

        if (
            SessioneUtente.getInstance().ruoliUtente ===
            Ruoli.Operatore_Laboratorio.descrizione
        ) {
            this.props.setSchedaSpecialeECorretto(
                this.state.oggettoBe,
                this.validate(),
                textListlab,
                true,
                "toasterMib"
            );
            this.props.setConfermaSchedaLab({ confermaSchedaUtenteLab: true });
        } else if (
            (SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp_HIV.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_Regionale.descrizione) &&
            this.state.schedaSpecialeMIB.agenteEziologicoMIB &&
            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                .malattiaBatterica === "malattiaBatterica1"
        ) {
            if (
                this.props.segnalazioneCopia &&
                this.props.segnalazioneCopia.schedaSpeciale &&
                this.props.segnalazioneCopia.stepConfermati
                    .schedaSpecialeConfermata
            ) {
                this.props.setSchedaSpecialeECorretto(
                    this.state.oggettoBe,
                    this.validate(),
                    textList,
                    true
                );
                this.props.setConfermaSchedaLab({
                    confermaSchedaUtenteLab: true,
                });
            } else {
                this.props.setSchedaSpecialeECorretto(
                    this.state.oggettoBe,
                    this.validate(),
                    textList,
                    false
                );
                if (
                    this.props.segnalazioneCopia &&
                    this.props.segnalazioneCopia.schedaSpeciale &&
                    this.props.segnalazioneCopia.schedaSpeciale
                        .confermaSchedaUtenteLabMIB
                ) {
                    this.props.setConfermaSchedaLab({
                        confermaSchedaUtenteLab: true,
                    });
                } else {
                    this.props.setConfermaSchedaLab({
                        confermaSchedaUtenteLab: false,
                    });
                }
            }
        } else if (
            (SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp_HIV.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_Regionale.descrizione) &&
            this.state.schedaSpecialeMIB.agenteEziologicoMIB &&
            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                .malattiaBatterica !== "malattiaBatterica1"
        ) {
            this.props.setSchedaSpecialeECorretto(
                this.state.oggettoBe,
                this.validate(),
                textList,
                correttoSispReg
            );
            if (
                this.props.segnalazioneCopia &&
                this.props.segnalazioneCopia.schedaSpeciale &&
                this.props.segnalazioneCopia.schedaSpeciale
                    .confermaSchedaUtenteLabMIB
            ) {
                this.props.setConfermaSchedaLab({
                    confermaSchedaUtenteLab: true,
                });
            } else {
                this.props.setConfermaSchedaLab({
                    confermaSchedaUtenteLab: false,
                });
            }
        }
    }

    mostraElementi(SISP) {
        if (SISP) {
            if (this.state.visualizzaSezioneSISP === false) {
                this.setState({ visualizzaSezioneSISP: true });
            } else if (this.state.visualizzaSezioneSISP === true) {
                this.setState({ visualizzaSezioneSISP: false });
            }
        } else {
            if (this.state.visualizzaSezione === false) {
                this.setState({ visualizzaSezione: true });
            } else if (this.state.visualizzaSezione === true) {
                this.setState({ visualizzaSezione: false });
            }
        }
    }

    setDatiCompilatoreMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.datiCompilatoreMIB = dati;
        oggettoBe["datiCompilatoreMIB"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setDatiAnagraficiMIB(dati, validateAnagrafica, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.datiAnagraficiMIB = dati;
        oggettoBe["datiAnagraficiMIB"] = datiBE;
        let validate = this.state.validateMIB;
        validate.datiAnagraficiMIB = validateAnagrafica;

        if (dati && datiBE && validateAnagrafica) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
                validateMIB: validate,
            });
        } else if (!dati && datiBE && validateAnagrafica) {
            this.setState({ oggettoBe: oggettoBe, validateMIB: validate });
        } else if (dati && !datiBE && validateAnagrafica) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                validateMIB: validate,
            });
        } else if (dati && datiBE && !validateAnagrafica) {
            this.setState({
                oggettoBe: oggettoBe,
                schedaSpecialeMIB: schedaSpecialeMIB,
            });
        } else if (dati && !datiBE && !validateAnagrafica) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (!dati && datiBE && !validateAnagrafica) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (!dati && !datiBE && validateAnagrafica) {
            this.setState({ validateMIB: validate });
        }

        this.controlloDati();
    }

    setAgenteEziologicoMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.agenteEziologicoMIB = dati;
        oggettoBe["agenteEziologicoMIB"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setMalattiaBattericaMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.malattiaBattericaMIB = dati;
        oggettoBe["malattiaBattericaMIB"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setSequeleFocolaioMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.sequeleFocolaioMIB = dati;
        oggettoBe["sequeleFocolaioMIB"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setStatoVaccinaleMIB(dati, validateStato, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.statoVaccinaleMIB = dati;
        oggettoBe["statoVaccinaleMIB"] = datiBE;
        let validate = this.state.validateMIB;
        validate.statoVaccinaleMIB = validateStato;

        if (dati && datiBE && validateStato) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
                validateMIB: validate,
            });
        } else if (!dati && datiBE && validateStato) {
            this.setState({ oggettoBe: oggettoBe, validateMIB: validate });
        } else if (dati && !datiBE && validateStato) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                validateMIB: validate,
            });
        } else if (dati && datiBE && !validateStato) {
            this.setState({
                oggettoBe: oggettoBe,
                schedaSpecialeMIB: schedaSpecialeMIB,
            });
        } else if (dati && !datiBE && !validateStato) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (!dati && datiBE && !validateStato) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (!dati && !datiBE && validateStato) {
            this.setState({ validateMIB: validate });
        }

        this.controlloDati();
    }

    setDiagnosiMIB(dati, validateDiagnosi, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.diagnosiMIB = dati;
        oggettoBe["diagnosiMIB"] = datiBE;
        let validate = this.state.validateMIB;
        validate.diagnosiMIB = validateDiagnosi;

        if (dati && datiBE && validateDiagnosi) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
                validateMIB: validate,
            });
        } else if (!dati && datiBE && validateDiagnosi) {
            this.setState({ oggettoBe: oggettoBe, validateMIB: validate });
        } else if (dati && !datiBE && validateDiagnosi) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                validateMIB: validate,
            });
        } else if (dati && datiBE && !validateDiagnosi) {
            this.setState({
                oggettoBe: oggettoBe,
                schedaSpecialeMIB: schedaSpecialeMIB,
            });
        } else if (dati && !datiBE && !validateDiagnosi) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (!dati && datiBE && !validateDiagnosi) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (!dati && !datiBE && validateDiagnosi) {
            this.setState({ validateMIB: validate });
        }

        this.controlloDati();
    }

    setDiagnosiNeisseriaMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.diagnosiNeisseria = dati;
        oggettoBe["diagnosiNeisseria"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setDiagnosiStreptococcusMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.diagnosiStreptococcus = dati;
        oggettoBe["diagnosiStreptococcus"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setDiagnosiInfluenzaMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.diagnosiInfluenza = dati;
        oggettoBe["diagnosiInfluenza"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    setAgenteMIB(dati, datiBE) {
        let schedaSpecialeMIB = this.state.schedaSpecialeMIB;
        let oggettoBe = this.state.oggettoBe;
        schedaSpecialeMIB.agenteMIB = dati;
        oggettoBe["agenteMIB"] = datiBE;

        if (dati !== undefined && datiBE === undefined) {
            this.setState({ schedaSpecialeMIB: schedaSpecialeMIB });
        } else if (dati === undefined && datiBE !== undefined) {
            this.setState({ oggettoBe: oggettoBe });
        } else if (dati !== undefined && datiBE !== undefined) {
            this.setState({
                schedaSpecialeMIB: schedaSpecialeMIB,
                oggettoBe: oggettoBe,
            });
        }

        this.controlloDati();
    }

    render() {
        const { t } = this.props;

        const titolo = <div></div>;

        const campoObbligatorio = (
            <div className="col-lg-12">
                <div className={stylesWelcome.mandatoryColor}>
                    {" "}
                    {t("DatiSegnalazioneAnagrafici.campoObbligatorio")}
                </div>
            </div>
        );

        const visualizzaElementiSezione = (
            <div>
                <fieldset
                    disabled={
                        (this.props.segnalazioneCopia &&
                            this.props.segnalazioneCopia.migrazione) ||
                        SessioneUtente.getInstance().ruoliUtente !==
                            Ruoli.Operatore_Laboratorio.descrizione ||
                        this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                        this.props.segnalazioneCopia.statoValidazione ===
                            OggettiUtili.statoValidazioneByLabel.Validata.codice
                    }
                >
                    <div style={{ paddingTop: "9px" }} />
                    <hr className={stylesWelcome.hr} />
                    <div style={{ paddingTop: "1rem" }} />
                    <DiagnosiMIB
                        statePadre={this.state.schedaSpecialeMIB.diagnosiMIB}
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setDiagnosiMIB={this.setDiagnosiMIB}
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <DiagnosiEseguitaNeisseriaMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.diagnosiNeisseria
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setDiagnosiNeisseria={this.setDiagnosiNeisseriaMIB}
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <DiagnosiEseguitaStreptococcus
                        statePadre={
                            this.state.schedaSpecialeMIB.diagnosiStreptococcus
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setDiagnosiStreptococcus={
                            this.setDiagnosiStreptococcusMIB
                        }
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <DiagnosiEseguitaInfluenzaMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.diagnosiInfluenza
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setDiagnosiInfluenza={this.setDiagnosiInfluenzaMIB}
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <AgenteCausanteMIB
                        statePadre={this.state.schedaSpecialeMIB.agenteMIB}
                        setAgenteMIB={this.setAgenteMIB}
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                    />
                </fieldset>
            </div>
        );

        const visualizzaElementiSezioneSISP = (
            <div>
                <fieldset
                    disabled={
                        (this.props.segnalazioneCopia &&
                            this.props.segnalazioneCopia.migrazione) ||
                        SessioneUtente.getInstance().ruoliUtente ===
                            Ruoli.Operatore_Laboratorio.descrizione ||
                        this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                        this.props.segnalazioneCopia.statoValidazione ===
                            OggettiUtili.statoValidazioneByLabel.Validata.codice
                    }
                >
                    <div style={{ paddingTop: "1rem" }} />
                    <DatiCompilatoreMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.datiCompilatoreMIB
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setDatiCompilatoreMIB={this.setDatiCompilatoreMIB}
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <DatiAnagraficiMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.datiAnagraficiMIB
                        }
                        datiPaziente={this.props.datiPaziente}
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setDatiAnagraficiMIB={this.setDatiAnagraficiMIB}
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <AgenteEziologicoMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setAgenteEziologicoMIB={this.setAgenteEziologicoMIB}
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <MalattiaBattericaMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.malattiaBattericaMIB
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                        setMalattiaBattericaMIB={this.setMalattiaBattericaMIB}
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <SqueleFocolaioMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.sequeleFocolaioMIB
                        }
                        setSequeleFocolaioMIB={this.setSequeleFocolaioMIB}
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                    />
                    <div style={{ paddingTop: "2rem" }} />
                    <StatoVaccinaleMIB
                        statePadre={
                            this.state.schedaSpecialeMIB.statoVaccinaleMIB
                        }
                        setStatoVaccinaleMIB={this.setStatoVaccinaleMIB}
                        malattiaBatterica={
                            this.state.schedaSpecialeMIB.agenteEziologicoMIB
                                .malattiaBatterica
                                ? this.state.schedaSpecialeMIB
                                      .agenteEziologicoMIB.malattiaBatterica
                                : ""
                        }
                        segnalazioneCopia={
                            this.props.segnalazioneCopia
                                ? this.props.segnalazioneCopia
                                : ""
                        }
                    />
                    <div style={{ paddingTop: "2rem" }} />
                </fieldset>

                {campoObbligatorio}
            </div>
        );

        const visualizzaSezione = (
            <div>
                <Button
                    onClick={() => {
                        this.mostraElementi(false);
                    }}
                    className={
                        stylesWelcome.testo + " " + stylesWelcome.btnBluOutline
                    }
                    classes="btn mt-2 btnBluOutline mb-1 "
                    style={{
                        marginTop: "-30px",
                        outline: "none",
                        border: "none",
                        background: "none",
                        float: "right",
                        fontSize: "14px",
                    }}
                    text={
                        this.state.visualizzaSezione
                            ? t("SchedaFlussoSpeciale.MIB.Diagnosi.nascondi")
                            : t("SchedaFlussoSpeciale.MIB.Diagnosi.visualizza")
                    }
                    icon={
                        <Icon
                            style={{
                                fill: "#0073e6",
                                width: "32px",
                                height: "32px",
                                paddingBottom: "10px",
                            }}
                            id={
                                this.state.visualizzaSezione
                                    ? "it-minus-circle"
                                    : "it-plus-circle"
                            }
                        />
                    }
                />
                {this.state.visualizzaSezione === true ? (
                    <div>{visualizzaElementiSezione}</div>
                ) : (
                    <div></div>
                )}
            </div>
        );

        const visualizzaSezioneSISP = (
            <div>
                <Button
                    onClick={() => {
                        this.mostraElementi(true);
                    }}
                    className={
                        stylesWelcome.testo + " " + stylesWelcome.btnBluOutline
                    }
                    classes="btn mt-2 btnBluOutline mb-1 "
                    style={{
                        marginTop: "-30px",
                        outline: "none",
                        border: "none",
                        background: "none",
                        float: "right",
                        fontSize: "14px",
                    }}
                    text={
                        this.state.visualizzaSezioneSISP
                            ? t("SchedaFlussoSpeciale.MIB.Diagnosi.nascondi")
                            : t("SchedaFlussoSpeciale.MIB.Diagnosi.visualizza")
                    }
                    icon={
                        <Icon
                            style={{
                                fill: "#0073e6",
                                width: "32px",
                                height: "32px",
                                paddingBottom: "10px",
                            }}
                            id={
                                this.state.visualizzaSezioneSISP
                                    ? "it-minus-circle"
                                    : "it-plus-circle"
                            }
                        />
                    }
                />
                {this.state.visualizzaSezioneSISP === true ? (
                    <div>{visualizzaElementiSezioneSISP}</div>
                ) : (
                    <div></div>
                )}
            </div>
        );

        const diagnosiSezione = (
            <div>
                <div className={"row"} style={{ marginTop: "1rem" }}>
                    <div className={"col-lg-8"} style={{ marginTop: "1rem" }}>
                        <h6>{t("SchedaFlussoSpeciale.MIB.Diagnosi.titolo")}</h6>
                    </div>
                    <div className={"col-lg-12"}>{visualizzaSezione}</div>
                </div>
                <div>
                    {this.state.visualizzaSezione === false ? (
                        <div>
                            <hr className={stylesWelcome.hr} />
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
            </div>
        );

        const SISPSezione = (
            <div>
                <div className={"row"}>
                    <div className={"col-lg-8"}>
                        <div style={{ paddingTop: "2rem" }} />
                        <h6>{t("SchedaFlussoSpeciale.MIB.titolo")}</h6>
                    </div>
                    <div className={"col-lg-12"}>{visualizzaSezioneSISP}</div>
                </div>
                <div>
                    {this.state.visualizzaSezioneSISP === false ? (
                        <div>
                            <hr className={stylesWelcome.hr} />
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
            </div>
        );

        return (
            <div>
                <div
                    className={
                        (this.props.segnalazioneCopia &&
                            this.props.segnalazioneCopia.migrazione) ||
                        SessioneUtente.getInstance().ruoliUtente ===
                            Ruoli.Operatore_Laboratorio.descrizione ||
                        this.props.segnalazioneCopia.statoSegnalazione ===
                            OggettiUtili.statoSegnalazioneByLabel.Archiviato
                                .codice ||
                        this.props.segnalazioneCopia.statoValidazione ===
                            OggettiUtili.statoValidazioneByLabel.Validata.codice
                            ? "visualizzazione"
                            : ""
                    }
                >
                    {SISPSezione}
                </div>

                {diagnosiSezione}
            </div>
        );
    }
}

export default withTranslation("common")(SchedaSpecialeMIB);
